import React, { useEffect, useState } from 'react';
import styles from './HomePage.module.css';
import Hero from './Sections/Hero/Hero';
import RayvoOne from './Sections/RayvoOne/RayvoOne';
import Roadmap from './Sections/Roadmap/Roadmap';
import Nav from '../../components/Nav/Nav';
import Footer from '../../components/Footer/Footer';
import Subscribe from './Sections/Subscribe/Subscribe';
import About from './Sections/About/About';
import Partner from './Sections/Partner/Partner';
import GlassesDemo from './Sections/GlassesDemo/GlassesDemo';
import MobileApp from './Sections/MobileApp/MobileApp';

function HomePage() {
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;  
      const viewportHeight = window.innerHeight;
      
      setIsVisible({
        section3: scrollPosition > viewportHeight * 0.5,
        section4: scrollPosition > viewportHeight * 1,
        section3d: scrollPosition > viewportHeight * 1.5,
        roadmap: scrollPosition > viewportHeight * 2,
        features: scrollPosition > viewportHeight * 2.5,
        glasses: scrollPosition > viewportHeight * 0.8,
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.body}>
      <Nav />
      
      <Hero />
      
      <Partner/>
 
      <About />

      <GlassesDemo isVisible={isVisible.glasses}/>

      <MobileApp />
      <Roadmap/>
      
      <RayvoOne isVisible={isVisible.features} />

      <Subscribe />
      
      <Footer />
    </div>
  );
}

export default HomePage;